import { useEffect, useState } from 'react';
import { Checkbox } from '@mui/material';
import ScreenCard from '../Meeting/ScreenShare/ScreenCard';
import type { KatonMeetScreenRequest } from '../../electron';
import './KatonMeetScreenPicker.scss';

// Desktop app only: Katon Meet's screen share (getDisplayMedia inside the iframe) is answered by the
// Electron main process, which asks this page which screen or window to share.
const KatonMeetScreenPicker = () => {
  const [request, setRequest] = useState<KatonMeetScreenRequest | null>(null);
  const [selectedScreen, setSelectedScreen] = useState<string>();
  const [shareAudio, setShareAudio] = useState(false);

  useEffect(() => {
    const electron = window.electron;
    if (!electron?.isElectron?.() || !electron.registerKatonMeetScreenShare || !electron.onKatonMeetChooseScreen) return;
    electron.registerKatonMeetScreenShare();
    return electron.onKatonMeetChooseScreen((nextRequest) => {
      setRequest(nextRequest);
      setSelectedScreen(nextRequest.sources[0]?.id);
      setShareAudio(false);
    });
  }, []);

  if (!request) return null;

  // sourceId null = cancelled, which makes Katon Meet's getDisplayMedia() reject
  const respond = (sourceId: string | null) => {
    window.electron?.chooseKatonMeetScreen?.(request.requestId, sourceId, shareAudio);
    setRequest(null);
  };

  return (
    <div className="katonMeetScreenPicker" role="dialog" aria-label="Choose what to share">
      <div className="katonMeetScreenPicker__panel">
        <div className="katonMeetScreenPicker__title">Select which screen you want to share</div>
        <div className="katonMeetScreenPicker__screens">
          {request.sources.map((source, index) => (
            <ScreenCard
              key={source.id}
              data={source}
              index={index}
              selectedScreen={selectedScreen}
              setSelectedScreen={setSelectedScreen}
            />
          ))}
        </div>
        <div className="katonMeetScreenPicker__footer">
          {request.canShareAudio ? (
            <label className="katonMeetScreenPicker__audio">
              <Checkbox checked={shareAudio} onChange={() => setShareAudio(!shareAudio)} />
              Share Audio
            </label>
          ) : (
            <span />
          )}
          <div className="katonMeetScreenPicker__actions">
            <button type="button" className="katonMeetScreenPicker__button" onClick={() => respond(null)}>
              Cancel
            </button>
            <button
              type="button"
              className="katonMeetScreenPicker__button katonMeetScreenPicker__button--primary"
              disabled={!selectedScreen}
              onClick={() => respond(selectedScreen ?? null)}
            >
              Share
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KatonMeetScreenPicker;
